/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 430);
/******/ })
/************************************************************************/
/******/ ({

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(431);
module.exports = __webpack_require__(433);


/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_js_constants__ = __webpack_require__(432);
var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// NOTE: This is converted from video-a (renamed because video-b is not being converted).

var _window$Liftoff = window.Liftoff,
    Component = _window$Liftoff.Component,
    DOMUtils = _window$Liftoff.DOMUtils,
    Utils = _window$Liftoff.Utils,
    Logger = _window$Liftoff.Logger,
    LiftoffMRAID = _window$Liftoff.LiftoffMRAID;


var HTML = "\n  <div class=\"video\">\n    <canvas class=\"video-copy\"></canvas>\n    <div class=\"video-letterbox\"></div>\n    <video preload=\"auto\" webkit-playsinline playsinline>\n      <source class=\"mp4\" type=\"video/mp4\"></source>\n    </video>\n    <div class=\"video-progress\">\n      <div class=\"video-progress-bar\"></div>\n    </div>\n  </div>\n";
// A 1x1 pixel transparent GIF.
var TRANSPARENT_GIF = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

Component.register("video", function (_Component) {
  _inherits(Video, _Component);

  _createClass(Video, null, [{
    key: "unmute",
    value: function unmute() {
      var videos = document.getElementsByTagName("video");
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = videos[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var video = _step.value;

          if (!video.dataset.alwaysMute && video.muted) {
            video.muted = false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }]);

  function Video(config) {
    _classCallCheck(this, Video);

    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, config));

    Utils.assignWithDefaults(_this, {
      mp4: null,
      alwaysMute: false,
      vpos: "top",
      loop: true,
      letterboxColor: "transparent",
      letterboxColorFill: null,
      blurredLetterbox: false,
      blurAmount: 10,
      showProgress: false
    }, _this.config);

    _this.videoCanPlay = false;
    _this.videoMetaLoaded = false;
    return _this;
  }

  _createClass(Video, [{
    key: "load",
    value: function load() {
      this.el = DOMUtils.strToElement(HTML);
      this.el.classList.toggle("show-progress", this.showProgress);
      this.timeAtLoad = new Date();

      this.liftoffEl = document.getElementById("liftoff-layout");
      this.videoEl = this.el.querySelector("video");
      this.canvasEl = this.el.querySelector("canvas");
      this.letterboxEl = this.el.querySelector(".video-letterbox");
      this.canvasCtx = this.canvasEl.getContext("2d");
      this.videoEl.loop = this.loop;
      var mp4SourceEl = this.videoEl.querySelector(".mp4");
      if (this.mp4 == null) {
        mp4SourceEl.remove();
      } else {
        mp4SourceEl.src = this.mp4;
      }

      this.videoEl.setAttribute("poster", TRANSPARENT_GIF);
      var globalAudioPolicy = Liftoff.env.creative_policy.audio_policy;
      var alwaysMute = this.alwaysMute || globalAudioPolicy === __WEBPACK_IMPORTED_MODULE_0__src_js_constants__["a" /* AUDIO_POLICY_ALWAYS_MUTE */];
      this.videoEl.muted = alwaysMute || globalAudioPolicy === __WEBPACK_IMPORTED_MODULE_0__src_js_constants__["b" /* AUDIO_POLICY_ON_INTERACTION */];
      if (alwaysMute) {
        this.videoEl.dataset.alwaysMute = alwaysMute;
      }
      this.addEventListeners(globalAudioPolicy !== __WEBPACK_IMPORTED_MODULE_0__src_js_constants__["a" /* AUDIO_POLICY_ALWAYS_MUTE */]);

      if (this.blurredLetterbox) {
        this.videoEl.addEventListener("play", this.updateVideoBlur.bind(this));
      }

      this.videoEl.load();
      return this.metaDataLoadedPromise;
    }
  }, {
    key: "layout",
    value: function layout(parentNode) {
      _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), "layout", this).call(this, parentNode);
      this.parentNode.appendChild(this.el);
      this.resize();
    }

    // It's necessary to explicitly size the height of the video on iOS, because
    // otherwise, the video element fills the height of the container, getting
    // letterboxed and vertically centered within the container.

  }, {
    key: "resize",
    value: function resize() {
      var aspect = this.videoEl.videoWidth / this.videoEl.videoHeight;
      var newHeight = this.el.getBoundingClientRect().width / aspect;
      this.videoEl.style.height = newHeight + "px";
      this.el.classList.add("vpos-" + this.vpos);
      this.letterboxEl.style.background = this.letterboxColorFill ? this.letterboxColorFill : this.letterboxColor;

      if (this.blurredLetterbox) {
        this.canvasEl.width = 400;
        this.canvasEl.height = this.canvasEl.width / aspect;
        this.letterboxEl.style["-webkit-backdrop-filter"] = "blur(" + this.blurAmount + "px)";
        this.letterboxEl.style.backdropFilter = "blur(" + this.blurAmount + "px)";
      } else {
        this.letterboxEl.style["-webkit-backdrop-filter"] = null;
        this.letterboxEl.style.backdropFilter = null;
      }
      return true;
    }
  }, {
    key: "start",
    value: function start() {
      this.started = true;
      this.playIfReady();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.videoEl.pause();
    }
  }, {
    key: "restart",
    value: function restart() {
      this.stop();
      this.videoEl.currentTime = 0;
      this.start();
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners(unmute) {
      var _this2 = this;

      DOMUtils.addOneTimeListener(this.videoEl, "canplay", function () {
        Logger.recordMetricV2("video_canplay_ms", Date.now() - LIFTOFF_START_TS);
      });
      DOMUtils.addOneTimeListener(this.videoEl, "canplaythrough", function () {
        Logger.recordMetricV2("video_canplaythrough_ms", Date.now() - LIFTOFF_START_TS);
        _this2.videoCanPlay = true;
        _this2.playIfReady();
      });
      DOMUtils.addOneTimeListener(this.videoEl, "timeupdate", function () {
        _this2.videoEl.style.visibility = "visible";
      });
      if (unmute) {
        if (!Video.unmuteAdded) {
          Video.unmuteAdded = true;
          this.liftoffEl.addEventListener("mousedown", Video.unmute);
          this.liftoffEl.addEventListener("mouseup", Video.unmute);
        }
      }
      this.videoEl.addEventListener("ended", function () {
        return _this2.emit("videoComplete");
      });
      this.metaDataLoadedPromise = new Promise(function (resolve) {
        _this2.videoEl.addEventListener("loadedmetadata", function () {
          _this2.videoMetaLoaded = true;

          resolve();
        });
      });
      // We play this video on load. If mraid indicates that the ad has been
      // closed (hidden), then pause. Continue playback when the ad comes back
      // into view.
      LiftoffMRAID.onViewableChange(function (viewable) {
        try {
          if (viewable) {
            _this2.playIfReady();
          } else {
            _this2.videoEl.pause();
          }
        } catch (e) {
          _this2.error(e);
        }
      });
    }
  }, {
    key: "onProgressUpdate",
    value: function onProgressUpdate() {
      if (!(this.started && this.videoMetaLoaded)) return;

      var progress = this.videoEl.currentTime / this.videoEl.duration;
      this.el.querySelector(".video-progress-bar").style.width = progress * 100 + "%";

      if (!this.videoEl.paused) {
        requestAnimationFrame(this.onProgressUpdate.bind(this));
      }
    }

    // Renders and plays an MP4 video.

  }, {
    key: "playIfReady",
    value: function playIfReady() {
      var _this3 = this;

      var play = function play() {
        var promise = _this3.videoEl.play();
        _this3.onProgressUpdate();

        return promise;
      };

      if (this.videoCanPlay && this.started) {
        // `HTMLMediaElement.play()` returns a Promise in some browsers, but
        // support is poor. If a promise was returned, use it to try to re-play
        // the video on error. Otherwise, check after a fixed time if a video is
        // playing and try re-playing if necessary.
        var promise = play();
        if (promise != null && Utils.type(promise.catch) === "function") {
          promise.catch(play);
        } else {
          setTimeout(function () {
            if (_this3.videoEl.paused) {
              play();
            }
          }, 500);
        }
      }
    }
  }, {
    key: "updateVideoBlur",
    value: function updateVideoBlur() {
      if (this.videoEl.paused || this.videoEl.ended) return;
      this.canvasCtx.drawImage(this.videoEl, 0, 0, this.canvasEl.width, this.canvasEl.height);
      requestAnimationFrame(this.updateVideoBlur.bind(this));
    }
  }]);

  return Video;
}(Component));

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLATFORM_ANDROID */
/* unused harmony export PLATFORM_IOS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUDIO_POLICY_ALWAYS_MUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUDIO_POLICY_ON_INTERACTION; });
/* unused harmony export AUDIO_POLICY_NO_RESTRICTIONS */
/* unused harmony export EXCHANGE_APPLOVIN */
/* unused harmony export EXCHANGE_IRONSOURCE */
/* unused harmony export EXCHANGE_MOPUB */
/* unused harmony export EXCHANGE_TAPJOY */
/* unused harmony export EXCHANGE_MINTEGRAL */
/* unused harmony export ORIENTATION_PORTRAIT */
/* unused harmony export ORIENTATION_LANDSCAPE */
/* unused harmony export CONNECTION_TYPE_WIFI */
/* unused harmony export CLICK_AREA_TYPE_OTHER */
/* unused harmony export CLICK_AREA_TYPE_CTA */
/* unused harmony export CLICK_METRIC_TYPE_CLOSE */
/* unused harmony export CLICK_METRIC_TYPE_CTA */
/* unused harmony export CLICK_METRIC_TYPE_DEADZONE */
/* unused harmony export CLICK_METRIC_TYPE_UNKNOWN */
/* unused harmony export CLICK_REJECTION_REASON_UNKNOWN */
/* unused harmony export CLICK_REJECTION_REASON_NO_INTERACTIONS */
/* unused harmony export CLICKTHROUGH_URL_TYPE_LIFTOFF_ENDPOINT */
/* unused harmony export CLICKTHROUGH_URL_TYPE_APP_STORE */
/* unused harmony export CLICK_TRACKING_URL_TYPE_UNKNOWN */
/* unused harmony export CLICK_TRACKING_URL_TYPE_LIFTOFF_ENDPOINT */
/* unused harmony export TRACKING_METHOD_OPEN_METHOD */
/* unused harmony export TRACKING_METHOD_IMAGE */
/* unused harmony export TRACKING_METHOD_BEACON */
/* unused harmony export AUTOCLICK_TYPE_LAST_INTERACTION */
/* unused harmony export AUTOCLICK_TYPE_INTERACTION_COUNT */
/* unused harmony export AUTOCLICK_TYPE_LAST_INTERACTION_AND_INTERACTION_COUNT */
/* unused harmony export AUTOCLICK_TYPE_COMPLETED_DELAY */
/* unused harmony export AUTOCLICK_TYPE_LOAD_DELAY */
/* unused harmony export AUTOCLICK_TYPE_VIEWABLE_DELAY */
/* unused harmony export AUTOCLICK_TYPE_VIEWABLE_DELAY_WITH_RESET */
/* unused harmony export CLICK_OPEN_METHOD_WINDOW_OPEN */
/* unused harmony export CLICK_OPEN_METHOD_MRAID */
/* unused harmony export CLICK_OPEN_METHOD_ANCHOR */
/* unused harmony export CLICK_OPEN_METHOD_LOCATION */
var PLATFORM_ANDROID = "android";
var PLATFORM_IOS = "ios";

var AUDIO_POLICY_ALWAYS_MUTE = "always-mute";
var AUDIO_POLICY_ON_INTERACTION = "on-interaction";
var AUDIO_POLICY_NO_RESTRICTIONS = "no-restrictions";

// TODO(Casey): Use constants instead of string literals for all exchanges
// throughout.
var EXCHANGE_APPLOVIN = "applovin";
var EXCHANGE_IRONSOURCE = "ironsource";
var EXCHANGE_MOPUB = "mopub";
var EXCHANGE_TAPJOY = "tapjoy";
var EXCHANGE_MINTEGRAL = "mintegral";

var ORIENTATION_PORTRAIT = "portrait";
var ORIENTATION_LANDSCAPE = "landscape";

// These must correspond to the rtb.proto ConnectionType enum definition.
var CONNECTION_TYPE_WIFI = 2;

// These must correspond to the rtb.proto ClickAreaType enum definition.
var CLICK_AREA_TYPE_OTHER = 1;
var CLICK_AREA_TYPE_CTA = 3;

var CLICK_METRIC_TYPE_CLOSE = "CLOSE";
var CLICK_METRIC_TYPE_CTA = "CTA";
var CLICK_METRIC_TYPE_DEADZONE = "DEADZONE";
var CLICK_METRIC_TYPE_UNKNOWN = "UNKNOWN_CLICK_TYPE";

// This must correspond to the rtb.proto ClickRejectionReason enum definition.
var CLICK_REJECTION_REASON_UNKNOWN = 0;
var CLICK_REJECTION_REASON_NO_INTERACTIONS = 1;

// This must correspond to the auction.proto ClickthroughURLType.
var CLICKTHROUGH_URL_TYPE_LIFTOFF_ENDPOINT = 1;
var CLICKTHROUGH_URL_TYPE_APP_STORE = 2;

// This must correspond to the auction.proto ClickTrackingURLType.
var CLICK_TRACKING_URL_TYPE_UNKNOWN = 0;
var CLICK_TRACKING_URL_TYPE_LIFTOFF_ENDPOINT = 1;

// This must correspond to the rtb.proto TrackingMethod enum definition.
var TRACKING_METHOD_OPEN_METHOD = 1;
var TRACKING_METHOD_IMAGE = 2;
var TRACKING_METHOD_BEACON = 3;

var AUTOCLICK_TYPE_LAST_INTERACTION = "lastInteraction";
var AUTOCLICK_TYPE_INTERACTION_COUNT = "interactionCount";
var AUTOCLICK_TYPE_LAST_INTERACTION_AND_INTERACTION_COUNT = "lastInteractionAndInteractionCount";
var AUTOCLICK_TYPE_COMPLETED_DELAY = "completedDelay";
var AUTOCLICK_TYPE_LOAD_DELAY = "loadDelay";
var AUTOCLICK_TYPE_VIEWABLE_DELAY = "viewableDelay";
var AUTOCLICK_TYPE_VIEWABLE_DELAY_WITH_RESET = "viewableDelayWithReset";

var CLICK_OPEN_METHOD_WINDOW_OPEN = "window_open";
var CLICK_OPEN_METHOD_MRAID = "mraid";
var CLICK_OPEN_METHOD_ANCHOR = "anchor";
var CLICK_OPEN_METHOD_LOCATION = "location";

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// video.js